import React from 'react'
import { Form, Input, Row, Col, Button } from 'antd';
import {  DataRequestAction } from 'redux/actions/http';
import { useDispatch, useSelector } from 'react-redux'
import IntlMessages from "util/IntlMessages"
import SimpleModal from 'components/Modal/SimpleModal'
const ResetPasswordModal = () => {

    const userProps = useSelector(state => state.users)
    const {  passwordModelVisible,initialValues } = userProps

    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const onFinish = values => {
        values._id = initialValues._id
        dispatch(DataRequestAction('PUT', 'changeUserPassword', values, '', 'changingUserPassword', false))
    };

    return (
        <SimpleModal title={
            <span style={{ color: '#041649' }} className="gx-font-sans-bold">{<IntlMessages id="users.modal.resetPassword" />} </span>
        }
            modalFor="ResetPassword_Modal"
            visible={passwordModelVisible}>

            <Form
                layout="vertical"
                name="resetPasswprd"
                onFinish={onFinish}
                form={form}

            >
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                        <Form.Item
                            name="password"
                            label={<IntlMessages id="users.modal.password" />}
                            rules={[
                                {
                                    required: true,
                                    message: <IntlMessages id="users.modal.password_message" />,
                                },
                            ]}

                        >
                            <Input.Password />
                        </Form.Item>
                    </Col>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">

                        <Form.Item
                            name="confirmPassword"
                            label={<IntlMessages id="users.modal.confirmPassword" />}
                            dependencies={['password']}

                            rules={[
                                {
                                    required: true,
                                    message: <IntlMessages id="users.modal.confirmPassword_message" />,
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(<IntlMessages id="users.modal.passwordNotMatchMessage" />);
                                    },
                                }),
                            ]}
                        >

                            <Input.Password />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                        <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">

                            <Form.Item className="gx-mb-0">
                                <Button type="default" className="gx-pt-0 gx-mb-0 gx-mr-2" htmlType="button" onClick={() => dispatch({
                                    type: 'ResetPassword_Modal',

                                })}>
                                    <IntlMessages id="users.modal.cancel" />
                                </Button>
                            </Form.Item>
                            <Form.Item className="gx-mb-0">
                                <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                    <IntlMessages id="users.modal.reset" />
                                </Button>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </SimpleModal>
    )
}

export default ResetPasswordModal
